/**
 * Enumeration for the current user states.
 *
 * @readonly
 * @enum {string}
 */
export const CurrentUserStates = Object.freeze({
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    EXPIRED: 'EXPIRED',
    FUTURE: 'FUTURE'
})
